module.exports = __webpack_public_path__ + "img/43118aa.svg";